/**
 * ArchiPro market email domains. Keep in step with
 * `SupportedCountry::domain()` / `ArchiproStaff::emailIsStaff`.
 */
const ARCHIPRO_STAFF_EMAIL_DOMAINS = [
    'archipro.co.nz',
    'archipro.com.au',
    'archiproamerica.com',
] as const;

/**
 * True when the address is on an ArchiPro market domain (`@` + domain).
 * GraphQL `IsArchiproStaff` is roster membership on the system professional and
 * is not this check.
 */
export function isArchiproStaffEmail(email: string): boolean {
    const normalised = email.trim().toLowerCase();
    if (normalised === '') {
        return false;
    }

    return ARCHIPRO_STAFF_EMAIL_DOMAINS.some((domain) =>
        normalised.endsWith(`@${domain}`),
    );
}

/**
 * True when HubSpot must call `doNotTrack` and skip identify / pageviews.
 * Staff emails are the HubSpot-cookie pollution path; roster staff are excluded too.
 */
export function isHubspotStaffUser(user: {
    __typename: string;
    Email?: string;
    IsArchiproStaff?: boolean;
}): boolean {
    if (user.__typename !== 'Me') {
        return false;
    }

    return (
        user.IsArchiproStaff === true || isArchiproStaffEmail(user.Email ?? '')
    );
}
